
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';
import {useTicketStore} from '../../stores/TicketStore';
import {storeToRefs} from 'pinia'
import PriceTendencyLegend from "../../components/price-tendencies/PriceTendencyLegend.vue";
import PriceTendency from "../../components/price-tendencies/PriceTendency.vue";
import SeasonsLegend from "../../components/seasons/SeasonsLegend.vue";
import Calendar from "../../components/calendar/Calendar.vue";
import CalendarSelection from "../../components/calendar/CalendarSelection.vue";

export default defineComponent({
    name: 'CalendarView',
    components: {
        PriceTendencyLegend,
        PriceTendency,
        SeasonsLegend,
        Calendar,
        CalendarSelection
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        ticketId: {
            type: String,
            required: true,
        },
        isAnnualPass: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const ticketStore = useTicketStore();
        const {
            step,
            selectedDateStart,
            selectedDateEnd,
            hideServiceView,
            noAvailableDates,
            presalesExpiredMessage
        } = storeToRefs(ticketStore);

        const {changeStep, changeDateStart, changeDateEnd, changeHideServiceView, changeNoAvailableDates, resetServiceStep, changeMinSelectableDates, changePresalesExpiredMessage} = ticketStore;

        const hidePriceTendencyLegend = ref(false);
        const isLoadingPrice = ref(false);

        const isMobile = matchMedia('(max-width: 767px)').matches;


        const onHidePriceTendency = (bool) => {
            hidePriceTendencyLegend.value = bool;
        }

        const onChangeLoadingPrice = (bool) => {
            isLoadingPrice.value = bool;
        }

        const onChangeStep = (step: number) => {
            changeStep(step);
            changeNoAvailableDates(false);
        }

        const onChangeDateStart = (date: string) => {
            changeDateStart(date);
            resetServiceStep();
            changeNoAvailableDates(false);

        }

        const onChangeDateEnd = (date: string) => {
            if(!props.isAnnualPass) {
                changeDateEnd(date);
            } else {
                let date = new Date(selectedDateStart.value);
                date.setFullYear(new Date(selectedDateStart.value).getFullYear() + 1);
                changeDateEnd(date.toISOString());
            }
            resetServiceStep();
        }

        const onHideServiceView = (bool) => {
            changeHideServiceView(bool);
        }

        return {
            step,
            selectedDateStart,
            selectedDateEnd,
            changeStep,
            onChangeStep,
            onChangeDateStart,
            onChangeDateEnd,
            onHideServiceView,
            onHidePriceTendency,
            hidePriceTendencyLegend,
            changeMinSelectableDates,
            noAvailableDates,
            changeNoAvailableDates,
            changePresalesExpiredMessage,
            presalesExpiredMessage,
            onChangeLoadingPrice,
            isMobile,
            isLoadingPrice,
            translate
        };
    }
});
